import type {
  AdminAccount,
  AdminGetAccountByEmailParams,
  AdminGetAccountByPhoneParams,
  AdminGetAccountParams,
  AdminGetMissionsParams,
  AdminGetUserByEmailParams,
  AdminGetUserByPhoneParams,
  AdminGetUserOtcHistoryParams,
  AdminGetUserParams,
  AdminGetUserPortfolioParams,
  AdminListAccountsParams,
  AdminCreateAccountInput,
  AdminToggleAccountActiveInput,
  AdminSetPhoneInput,
  AdminSetEmailInput,
  AdminListUserBankAccountsParams,
} from '../api'
import { api } from '../api'

const adminGetAccount = async (params: AdminGetAccountParams) => {
  return await api.v1.adminGetAccount(params)
}

const adminCreateAccount = async (data: AdminCreateAccountInput) => {
  return await api.v1.adminCreateAccount(data)
}

const adminToggleAccountActive = async (
  data: AdminToggleAccountActiveInput,
) => {
  return await api.v1.adminToggleAccountActive(data)
}

const adminGetAccountByEmail = async (params: AdminGetAccountByEmailParams) => {
  return await api.v1.adminGetAccountByEmail(params)
}

const adminGetAccountByPhone = async (params: AdminGetAccountByPhoneParams) => {
  return await api.v1.adminGetAccountByPhone(params)
}

const adminGetUser = async (params: AdminGetUserParams) => {
  return await api.v1.adminGetUser(params)
}

const adminListAccounts = async (params: AdminListAccountsParams) => {
  return await api.v1.adminListAccounts(params)
}

/**
 * Add email to an account that doesn't have one
 */
const addEmailToAccount = async (
  input: AdminSetEmailInput,
): Promise<AdminAccount> => {
  const response = await api.v1.adminSetAccountEmail(input)
  return response.data
}

/**
 * Add phone to an account that doesn't have one
 */
const addPhoneToAccount = async (
  input: AdminSetPhoneInput,
): Promise<AdminAccount> => {
  const response = await api.v1.adminSetAccountPhone(input)
  return response.data
}

const adminGetUserByEmail = async (params: AdminGetUserByEmailParams) => {
  return await api.v1.adminGetUserByEmail(params)
}

const adminGetUserByPhone = async (params: AdminGetUserByPhoneParams) => {
  return await api.v1.adminGetUserByPhone(params)
}

const adminGetUserById = async (params: AdminGetUserParams) => {
  return await api.v1.adminGetUser(params)
}

const adminGetMissions = async (params: AdminGetMissionsParams) => {
  return await api.v1.adminGetMissions(params)
}

const adminGetUserPortfolio = async (params: AdminGetUserPortfolioParams) => {
  return await api.v1.adminGetUserPortfolio(params)
}

const adminGetUserOtcHistory = async (params: AdminGetUserOtcHistoryParams) => {
  return await api.v1.adminGetUserOtcHistory(params)
}

const adminDeleteUser = async (id: number) => {
  return await api.v1.adminDeleteUser({ userID: id })
}

const adminListUserBankAccounts = async (
  params: AdminListUserBankAccountsParams,
) => {
  return await api.v1.adminListUserBankAccounts(params)
}

export default {
  adminGetAccount,
  adminCreateAccount,
  adminToggleAccountActive,
  adminGetAccountByEmail,
  adminGetAccountByPhone,
  adminGetUser,
  adminListAccounts,
  addEmailToAccount,
  addPhoneToAccount,
  adminGetUserByEmail,
  adminGetUserByPhone,
  adminGetUserById,
  adminGetMissions,
  adminGetUserPortfolio,
  adminGetUserOtcHistory,
  adminDeleteUser,
  adminListUserBankAccounts,
}
